import localeCore from './locale';
export default {
	locale: localeCore.get(),
	languages: [
		{ locale: 'no', text: 'Norsk' },
		{ locale: 'en', text: 'English' }
	],
	allAvailableSettings : [
		{
			id: null,
			value: null,
			description: null,
			changed:false,
			data: [
				{
					changeDate: null,
					user: null,
					oldValue: null,
					newValue: null
				}
			]
		}
	],
	loading: {
		allAvailableSettings: false,
	}
};
